import { useRef, useEffect, useCallback } from 'react';

const useAbortableRequest = () => {
  const abortControllerRef = useRef(null);

  useEffect(
    () => () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    },
    []
  );

  const getSignal = useCallback(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    return abortController.signal;
  }, []);

  const isAbortError = useCallback(
    (error) => error.name === 'CanceledError' || error.name === 'AbortError',
    []
  );
  return { getSignal, isAbortError };
};

export default useAbortableRequest;
